module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.editing) ? _c('div', {
    staticClass: "row report-template",
    attrs: {
      "data-id": _vm.template.id
    }
  }, [_c('div', {
    staticClass: "col-md-9 contents"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('strong', {
    staticClass: "col-md-12 title",
    domProps: {
      "innerHTML": _vm._s(_vm.templateName(_vm.template))
    }
  })]), (_vm.isExpanded) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11 push-md-1 field intro"
  }, [_c('strong', [_vm._v("Day Of Week")]), _c('p', [_vm._v(_vm._s(_vm.template.dow))])]), _c('div', {
    staticClass: "col-md-11 push-md-1 field intro"
  }, [_c('strong', [_vm._v("Time Of Day")]), _c('p', [_vm._v(_vm._s(_vm.template.tod))])]), _c('div', {
    staticClass: "col-md-11 push-md-1 field intro"
  }, [_c('strong', [_vm._v("Intro:")]), _c('p', [_vm._v(_vm._s(_vm.template.intro))])]), _c('div', {
    staticClass: "col-md-11 push-md-1 field outro"
  }, [_c('strong', [_vm._v("Outro:")]), _c('p', [_vm._v(_vm._s(_vm.template.close))])]), _c('div', {
    staticClass: "col-md-10 push-md-2 images"
  }, [_c('strong', [_vm._v("Images:")]), _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "image"
    }, [_c('strong', {
      staticClass: "row col-md-12 title"
    }, [_vm._v(_vm._s(image.title))]), _c('div', {
      staticClass: "row col-md-12 text"
    }, [_vm._v(_vm._s(image.text))]), (image.timeout) ? _c('div', {
      staticClass: "row timeout"
    }, [_c('strong', {
      staticClass: "col-md-2"
    }, [_vm._v("Timeout:")]), _c('span', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(image.timeout))])]) : _vm._e(), (image.width) ? _c('div', {
      staticClass: "row width"
    }, [_c('strong', {
      staticClass: "col-md-2"
    }, [_vm._v("Width:")]), _c('span', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(image.width))])]) : _vm._e(), (image.height) ? _c('div', {
      staticClass: "row height"
    }, [_c('strong', {
      staticClass: "col-md-2"
    }, [_vm._v("Height:")]), _c('span', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(image.height))])]) : _vm._e()])
  })], 2)]) : _vm._e()]), _c('div', {
    staticClass: "col-md-3 actions"
  }, [_c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onToggleExpand.apply(null, arguments)
      }
    }
  }, [(!_vm.isExpanded) ? _c('span', [_vm._v("More")]) : _vm._e(), (_vm.isExpanded) ? _c('span', [_vm._v("Less")]) : _vm._e()]), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onEdit.apply(null, arguments)
      }
    }
  }, [_vm._v("Edit")]), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onCopy.apply(null, arguments)
      }
    }
  }, [_vm._v("Copy")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onDelete.apply(null, arguments)
      }
    }
  }, [_vm._v("Delete")])], 1)]) : _c('report-template-form', {
    attrs: {
      "template": _vm.template
    },
    on: {
      "save": function($event) {
        _vm.editing = false
      },
      "cancel": function($event) {
        _vm.editing = false
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99b8285a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report-template.vue
// module id = 280
// module chunks = 1